import { flattenWidgets, PacBeat } from '@bariendo/lib/patient-access-script';
import { createContext, useContext } from 'react';

/**
 * The PN card v2.0's section body (BAR-2994): every row is Question · Script ·
 * Answer on three columns. Undefined, the default, is the shipped layout: the
 * question and its answer on one line, the script under them. Only the v2.0
 * card provides it, so every other card renders as it always has.
 */
export interface PacColumnsLayout {
  /** False once the navigator picks Hide script: the Script column goes. */
  showScript: boolean;
  /** Whether any row of this section has a script. Outcome has none, so it has no Script column. */
  scripted: boolean;
}

export const PacLayoutContext = createContext<PacColumnsLayout | undefined>(undefined);

/** The three columns the section header and every row sit on. */
export const QSA_GRID = { display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', columnGap: 16 } as const;

/** How wide an answer's input is: beside its question on the shipped card, its whole column on v2.0. */
export function useAnswerWidth(): string {
  return useContext(PacLayoutContext) ? '100%' : '56%';
}

/** Whether any row of a section has a line to read. Outcome has none, so it draws no Script column. */
export function sectionHasScript(beat: PacBeat): boolean {
  return flattenWidgets(beat.items).some(
    (widget) =>
      widget.kind === 'script' ||
      widget.kind === 'conditionalScript' ||
      ('say' in widget && Boolean(widget.say)) ||
      ('sayByProcedure' in widget && Boolean(widget.sayByProcedure))
  );
}
